import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  isRouteErrorResponse,
} from "react-router";
import * as Sentry from "@sentry/react-router";
import { useEffect } from "react";
import "./tailwind.css";
import { NavigationProgress } from "./components/navigation-progress";
import { ThemeScript } from "~providers/theme-provider";

export function headers() {
  return {
    "Cache-Control": "no-cache, no-store, must-revalidate",
  };
}

export function meta() {
  return [
    {
      name: "view-transition",
      content: "same-origin",
    },
  ];
}

export function links() {
  return [
    { rel: "icon", href: "/favicon.ico", sizes: "48x48" },
    { rel: "icon", href: "/favicon.svg", type: "image/svg+xml" },
    { rel: "icon", href: "/favicon-16x16.png", sizes: "16x16", type: "image/png" },
    { rel: "icon", href: "/favicon-32x32.png", sizes: "32x32", type: "image/png" },
    { rel: "apple-touch-icon", href: "/apple-touch-icon.png", sizes: "180x180" },
  ];
}

export default function App() {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
        <ThemeScript />
      </head>
      <body>
        <NavigationProgress />
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export function ErrorBoundary({ error }: { error: unknown }) {
  useEffect(() => {
    if (!isRouteErrorResponse(error)) {
      Sentry.captureException(error);
    }
  }, [error]);

  const is404 = isRouteErrorResponse(error) && error.status === 404;

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="max-w-md w-full text-center">
          <h1 className="text-2xl font-semibold text-foreground mb-2">
            {is404 ? "Page Not Found" : "Something Went Wrong"}
          </h1>
          <p className="text-muted-foreground mb-6">
            {is404
              ? "The page you're looking for doesn't exist."
              : "An unexpected error occurred. Our team has been notified."}
          </p>
          <a
            href="/"
            className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md text-white bg-primary hover:bg-primary/90"
          >
            Go to Dashboard
          </a>
        </div>
        <Scripts />
      {/* impeccable-live-start */}
<script src="http://localhost:8400/live.js"></script>
{/* impeccable-live-end */}
</body>
    </html>
  );
}
